export default __webpack_public_path__ + "static/media/gm-gp-girl.4734a2c6.webp";